// extracted by mini-css-extract-plugin
module.exports = {"lockingPeriod":"styles_lockingPeriod__1Ikhb","text":"styles_text__9UtkM"};